import React from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import DomainUpdateContactWizard from "./DomainUpdateContactWizard";
import {connect} from "react-redux";
import DomainInfoUpdateBox from "../../Box/DomainInfoCustomableBox";

class DomainUpdateContact extends React.Component {

    state = {
        viewType: 'tab',
        col: 1,

    }

    onChangeView(type, col) {
        this.setState({viewType: type})
        this.setState({col: col})
    }

    render() {
        const {infoDomainData, intl} = this.props;
        const {formatMessage} = intl;
        return (
            <div>
                <DomainInfoUpdateBox
                    title={formatMessage({id: "domain.update.contact.form.title"})}
                    hasRegistrarPermission={this.props.hasRegistrarPermission}
                    infoData={this.props.infoDomainData.data}
                    error={this.props.updateDomainHostData.error}
                    loading={this.props.updateDomainHostData.loading}
                    message={this.props.updateDomainHostData.message}
                    reset={this.props.reset}
                >
                    <DomainUpdateContactWizard fields={{domainData: infoDomainData.data}}
                                               onDone={this.props.onUpdateContact}
                                               onCancel={this.props.onCancel}
                    />
                </DomainInfoUpdateBox>
            </div>
        )
    }
}

DomainUpdateContact.propTypes = {
    hasRegistrarPermission: PropTypes.bool,
    onCancel: PropTypes.func,
    onUpdateContact: PropTypes.func,
    reset: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        infoDomainData: state.domain.infoReducer,
        updateDomainHostData: state.domain.updateReducer
    };
}

export default connect(mapStateToProps)(injectIntl(DomainUpdateContact));

